import { Either } from '@ajtec/either-typescript';
import { ILabs } from '../entities/lab-images';
import { IAboutRepository } from '../repositories/about-repository';

export class GetLabs {
	repository: IAboutRepository;

	constructor(homeRepository: IAboutRepository) {
		this.repository = homeRepository;
	}

	call(): Promise<Either<string, ILabs[]>> {
		return this.repository.getLabs();
	}
}
